import { z } from "zod/v4";

export const PluginDownSamplingSchema_2023_08_20 = z.object({
  initialLoads: z.number(),
  multiplier: z.number(),
});
export type PluginDownSamplingType_2023_08_20 = z.infer<
  typeof PluginDownSamplingSchema_2023_08_20
>;
